import * as ko from "knockout";
import entityBase from "entityBase";

export class team extends entityBase {
  team_id: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  user_def1: KnockoutObservable<string>;
  team_group: KnockoutObservable<string>;

  constructor(item: any) {
    super();
    this.team_id = ko.observable(item?.team_id);
    this.description = ko.observable(item?.description);
    this.user_def1 = ko.observable(item?.user_def1 || "N");
    this.team_group = ko.observable(item?.team_group);
  }
}
